import { foldForSearch } from "../../helper/searchFold";

/**
 * The series' books after a pick, in the order they were picked.
 *
 * The first book chosen is #1, the next #2. Picks used to go to the FRONT,
 * which put the book chosen last at the top — backwards for a series, which is
 * entered in reading order.
 *
 * Removal still belongs to the grid below the picker, so a book missing from
 * [options] is dropped here; a book already in the series keeps its STORED
 * name rather than the picker's label, which carries " — Author" for search.
 *
 * Its own module rather than a function inside the popup: the popup pulls in
 * axios, the router and two contexts, none of which this rule needs.
 */
export const mergePickedBooks = (current = [], options = []) => {
    const currentIds = new Set(current.map((b) => b.bookId));
    const incoming = (options || []).map((o) => ({ bookId: o.value, bookName: o.label }));
    const incomingIds = new Set(incoming.map((b) => b.bookId));

    const added = incoming.filter((b) => !currentIds.has(b.bookId));
    const kept = current.filter((b) => incomingIds.has(b.bookId));
    return [...kept, ...added];
};

/**
 * What the picker says when a search turns up nothing.
 *
 * A book already in the series is no longer offered, so searching for one by
 * name found "no books" — which reads as "we don't have that book" about a
 * book sitting in the grid below. Say what actually happened instead.
 */
export const searchEmptyMessage = (inputValue, picked = []) => {
    const term = foldForSearch(String(inputValue || "").trim());
    if (!term) return "Start typing to search books...";

    const already = (picked || []).filter((b) =>
        foldForSearch(b.bookName).includes(term)
    );
    if (already.length === 1) return `"${already[0].bookName}" is already in this series`;
    if (already.length > 1) return `${already.length} matching books are already in this series`;

    return `No books found for "${inputValue}"`;
};
